import React from "react";

export default function SubBrandFacet({ handleFilterClick, productSubBrands }) {
  const wpProductCategory = window.wpProductCategory;
  const plpFacetLabel = wpProductCategory.plpFacetLabel;
  const title =
    plpFacetLabel &&
    Object.keys(plpFacetLabel)?.length > 0 &&
    plpFacetLabel.hasOwnProperty("sub_brand") &&
    plpFacetLabel.sub_brand != ""
      ? plpFacetLabel.sub_brand
      : "Product Line";
  return (
    <div class="facet-wrap facet-display">
      <strong>{title}</strong>
      <div className="facetwp-facet">
        {Object.keys(productSubBrands).map((brand, i) => {
          if (brand && productSubBrands[brand] > 0) {
            return (
              <div>
                <span
                  id={`sub-brand-filter-${i}`}
                  key={i}
                  data-value={`${brand.toLowerCase()}`}
                  onClick={(e) =>
                    handleFilterClick("sub_brand", e.target.dataset.value)
                  }>
                  {" "}
                  {brand} {` (${productSubBrands[brand]}) `}
                </span>
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
}
